// Core primitives
export { BaseIcon } from "./BaseIcon";
export type { BaseIconProps } from "./BaseIcon";

export { IconStack } from "./IconStack";
export type { IconStackProps } from "./IconStack";

export { IconButton } from "./IconButton";
export type { IconButtonProps } from "./IconButton";

// Shared types
export type { IconSize, IconVariant, IconStackOverlap, IconButtonVariant, IconButtonSize } from "./types";
